module.exports = __webpack_public_path__ + "static/img/brain.3458758.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/memes/brain.jpg
// module id = BRAu
// module chunks = 1